import axios from "axios";

const axiosConfig = axios.create({
  baseURL: "https://emailsender.singlec.com.br/api/",
});
axiosConfig.defaults.headers["Content-Type"] = "application/json";
axiosConfig.interceptors.response.use(
  (response) => response,
  (error) => { console.log(error.message); return Promise.reject(error); },
);

export const emailApi = axiosConfig;
